// @flow
import React from 'react';

import { withTheme } from '@material-ui/core/styles';
import { Fab } from '@material-ui/core';
import { Idle, NotIdle } from 'idlejs/dist';
import electron from '../../utils/electron';

const fabStyle = {
  position: 'absolute',
  zIndex: 10,
  top: 20,
  right: 20,
};

interface IProps {
  fullScreen: boolean;
  theme: Object;
  updateFullScreen: Function;
}

function FullScreenHamburger(props: IProps) {
  const [idle, setIdle] = React.useState(false);

  React.useEffect(() => {
    new Idle()
      .whenNot([
        {
          events: ['click', 'mousemove', 'mouseenter', 'keydown', 'touchstart'],
          target: window.document,
        },
      ])
      .whenNotInteractive()
      .within(3, 1000)
      .do(() => {
        setIdle(true);
      })
      .start();
    new NotIdle()
      .when([
        {
          events: ['click', 'mousemove', 'mouseenter', 'keydown', 'touchstart'],
          target: window.document,
        },
      ])
      .within(1, 300)
      .do(() => setIdle(false))
      .start();
  }, []);

  const { theme, fullScreen, updateFullScreen } = props;

  let heightOffset = '';
  if (window.isElectron) {
    const { remote } = electron;
    if (remote.process.platform === 'darwin') {
      heightOffset = ' - 28px'
    } else {
      heightOffset = ' - 32px'
    }
  }

  return (
    <div
      style={{
        overflowX: 'hidden',
        position: 'absolute',
        backgroundColor: theme.palette.background.default,
        display: fullScreen && !idle ? undefined : 'none',
        height: `calc(var(--vh, 1vh) * 100${heightOffset})`,
        width: '100px',
        fontFamily: theme.typography.fontFamily,
      }}
    >
      <Fab
        onClick={e => {
          updateFullScreen(e);
          // $FlowFixMe
          if (document.fullscreenElement && document.exitFullscreen)
            document.exitFullscreen();
        }}
        style={{ ...fabStyle }}
      >
        <i
          className="material-icons"
          style={{ fontSize: 30, cursor: 'pointer', outline: 'none' }}
        >
          menu
        </i>
      </Fab>
    </div>
  );
}

export default withTheme(FullScreenHamburger);
